/** Target maximum size (chars) for the prettified JSON block embedded in Bedrock prompts. */
export const AI_SUMMARY_PAYLOAD_MAX_CHARS = 95_000;

/** First-pass excerpt length per communication body (plaintext after HTML stripping). */
export const AI_SUMMARY_COMM_BODY_CHARS_INITIAL = 900;

/** Floor for per-communication excerpt when tightening under payload budget. */
export const AI_SUMMARY_COMM_BODY_CHARS_MIN = 280;

/** Excerpt caps for tasks, meetings, notes, proposals (up from coarse substring limits). */
export const AI_SUMMARY_ACTIVITY_TEXT_CHARS_INITIAL = 450;

export const AI_SUMMARY_ACTIVITY_TEXT_CHARS_MIN = 200;

/** Company/deal roster: cap how many CRM contacts appear in payloads before timeline trimming. */
export const AI_SUMMARY_CONTACT_ROSTER_CAP_INITIAL = 200;

export const AI_SUMMARY_CONTACT_ROSTER_CAP_MIN = 40;

/** Prefer keeping at least this many newest communications before other aggressive cuts. */
export const AI_SUMMARY_MIN_COMMUNICATIONS = 18;

/**
 * Ticket AI briefing: max plaintext chars for the ticket description after
 * S3 dual-read + HTML→plain. One field (not N rows) so this is richer than a
 * per-communication excerpt, but still bounded so Google Groups email HTML
 * (~100KB+) cannot dominate the Bedrock prompt.
 */
export const AI_TICKET_SUMMARY_DESCRIPTION_CHARS = 6_000;

/** Per ticket-update / time-entry note in the ticket briefing prompt. */
export const AI_TICKET_SUMMARY_NOTE_CHARS = 450;

/** Deal nuggets: short excerpts — model only emits 3 sentences. */
export const AI_DEAL_NUGGETS_COMM_BODY_CHARS = 400;

/** Quote draft: meeting/call notes that scoped the work (few rows, richer excerpts). */
export const AI_QUOTE_MEETING_BODY_CHARS = 1_200;

/** Solution Engineering “extract from notes”: per-item plaintext before the form/API. */
export const AI_SOLUTION_ENGINEERING_NOTE_CHARS = 400;

/** Cap how many timeline rows Solution Engineering dumps into the pain-points field. */
export const AI_SOLUTION_ENGINEERING_NOTE_TAKE = 12;
